<template>
  <div :class="[b(), className]" :style="styleSizeName">
    <div :ref="id" :style="styleChartName"></div>
  </div>
</template>

<script>
import {HAI_NAN_JSON} from "@/utils/areaData.js";
import worldJson from './world.json'
import {
  GEO_OPTION,
  MAP_SERIES,
  POSITION_MAP,
  LABEL_OPTION,
  LABEL_SERIES,
} from "./defaultOption.js";

export default {
  name: "worldMap",
  data() {
    return {
      bannerCount: 0,
      bannerCheck: "",
      centerData: [],
      geoOption: {...GEO_OPTION},
      mapSeries: {...MAP_SERIES},
      renderData: [],
      labelData: [
        {
          name: '泰安中联',
          value: [
            '116.908599',
            '36.197682',
            100,
            {
              name: '泰安中联',
              detail: '泰安中联水泥有限公司',
              code: 'tazl',
            }
          ]
        },
        {
          name: '冀东铜川',
          value: [
            '108.99861',
            '34.91344',
            100,
            {
              name: '冀东铜川',
              detail: '冀东水泥铜川有限公司万吨线',
              code: 'jdtc',
            }
          ]
        },
        {
          name: '桃江南方',
          value: [
            '112.2475',
            '28.313625',
            100,
            {
              name: '桃江南方',
              detail: '湖南桃江南方水泥有限公司',
              code: 'tjnf',
            }
          ]
        },
        {
          name: '韶峰南方',
          value: [
            '112.224919',
            '27.732802',
            100,
            {
              name: '韶峰南方',
              detail: '湖南韶峰南方水泥有限公司',
              code: 'sfnf',
            }
          ]
        }
      ],
      zoomData: 1,
    };
  },
  watch: {
    mapData() {
      this.updateChart();
    },
    width() {
      this.updateData();
    },
    height() {
      this.updateData();
    },
    zoom: {
      handler() {
        this.zoomData = this.zoom;
      },
      immediate: true,
    },
  },
  computed: {
    zoomShow() {
      return this.option.zoomShow || 1;
    },
    zoom() {
      return this.option.zoom || 1;
    },
    mapData() {
      return this.option.mapData || "";
    },
    borderWidth() {
      return this.option.borderWidth || 3;
    },
    borderColor() {
      return this.option.borderColor || "#389BB7";
    },
    areaColor() {
      return this.option.areaColor || "#0c162f";
    },
    empColor() {
      return this.option.empColor || "#fff";
    },
    empAreaColor() {
      return this.option.empAreaColor || "yellow";
    },
    color() {
      return this.option.color || "#fff";
    },
    roam() {
      return this.validData(this.option.roam, true);
    },
    fontSize() {
      return this.option.fontSize || 24;
    },
    bannerTime() {
      return this.option.bannerTime || 3000;
    },
    banner() {
      return this.option.banner;
    },
    locationData() {
      return (this.dataChart || []).map((ele) => {
        ele.zoom = ele.zoom || 1;
        const zoomData = this.zoomData < 1 ? 1 : this.zoomData;
        return Object.assign(
            (() => {
              if (ele.zoom <= zoomData) {
                return {
                  name: ele.name,
                };
              }
              return {};
            })(),
            {
              value: [ele.lng, ele.lat, ele.value],
            }
        );
      });
    },
  },
  methods: {
    handlerDimParam(param) {
      // 指标环图结构, 辅助指标显示在柱状图复用，通过assistTip字段加一层控制
      param.componentType = this.option.assistTip
          ? "indexRingGraph"
          : undefined;
      return param;
    },
    // 根据配置项设置相关option的值
    generateOptions() {
      const {
        borderColor = "#52F1F5",
        showLegend = false,
        legendType = "default",
        showToolTip = false,
        toolTipBgWidth = 200,
        toolTipBgHeight = 100,
        toolTipContent,
        showLabel = false,
        labelFontSize,
        labelColor,
        labelContent = [],
        labelMark,
        barColor = [],
        legendDirection = "vertical",
        legendPosition = "bottomLeft",
        legendSymbol = "circle",
        legendWidth = 12,
        legendHeight = 12,
        legendFontSize = 12,
        legendFontColor = "",
        bgImg = "",
      } = this.option;
      if (bgImg) {
        let img = document.createElement("img");
        img.src = bgImg;
        this.mapSeries.itemStyle.normal.areaColor.image = img;
      }
      this.mapSeries.itemStyle.normal.borderColor = borderColor;
      if (showLegend) {
        this.visualMap = {
          show: showLegend,
          type: legendType === "default" ? "piecewise" : legendType,
          orient: legendDirection,
          seriesIndex: 1,
          inRange: {
            symbol: legendSymbol,
            symbolSize: [legendWidth, legendHeight],
          },
          hoverLink: false,
          ...POSITION_MAP[legendPosition],
          textStyle: {
            fontSize: legendFontSize,
            color: legendFontColor,
          },
        };
      } else {
        this.visualMap = undefined;
      }

      // toolTipOption = {
      //   ...toolTipOption,
      //   show: showToolTip,
      // }
    },
    updateChart() {
      if (!this.mapData) {
        return;
      }
      this.generateOptions();
      // this.$axios(this.mapData).then((res) => {
      // console.log("res>>>>>", res);
      const data = worldJson;
      this.mapDataJson = data;
      const optionData = this.deepClone(data)
      optionData.features = optionData.features.map(item => {
        return {
          ...item,
          properties: {
            ...item.properties,
            name: item.properties.NAME_CHN || item.properties.name,
          }
        }
      });

      const mapNameData = optionData?.features.map((item) => {
        // const rendItem = this.data.find(rItem => rItem.name === (item.properties.NAME_CHN || item.properties.name))
        // if (rendItem) {
        //     return {
        //         name: (item.properties.NAME_CHN || item.properties.name),
        //         value: rendItem.value,
        //         label: {
        //             show: true,
        //             color: '#ffffff',
        //             fontSize: 18,
        //             fontWeight: 500,
        //             formatter: (val) => {
        //                 console.log(val)
        //                 if (this.option.showPercent) {
        //                     return `${val.name}\n${val.data.value}%`
        //                 } else {
        //                     return `${val.name}\n${val.data.value}`
        //                 }
        //             }
        //         }
        //     }
        // } else {
        return {
          name: (item.properties.NAME_CHN || item.properties.name),
          value: 0,
        }
        // }
      });
      this.geoOption.regions = mapNameData.map(item => {
        return {
          ...item,
          itemStyle: {
            areaColor: '#003399',
            borderColor: '#43ffff',
            borderWidth: 1,
          }
        }
      })
      this.geoOption.layoutCenter = [(this.option.centerLeft || 0.2) * 100 + '%', (this.option.centerTop || 0.7) * 100 + '%']
      this.geoOption.layoutSize = (this.option.zoom || 1) * 100 + '%'
      const optionSeries = [
        // {
        //   ...this.mapSeries,
        //   data: mapNameData,
        //   layoutCenter: [(this.option.centerLeft || 0.2) * 100 + '%', (this.option.centerTop || 0.7) * 100 + '%'],
        //   layoutSize: (this.option.zoom || 1) * 100 + '%'
        // },
        {
          ...LABEL_SERIES,
          label: {
            normal: {
              offset: [0, 0],
              position: 'bottom',
              show: true,
              color: "#ffffff",
              formatter: "{b}",
              textStyle: {
                color: "#ffffff"
              }
            },
            emphasis: {
              show: true
            }
          },
          itemStyle: {
            // normal: {
            //   show: true,
            //   color: {
            //     type: "linear",
            //     x: 0,
            //     y: 0,
            //     x2: 0,
            //     y2: 1,
            //     colorStops: [
            //       {
            //         offset: 0,
            //         color: "#F65857", // 0% 处的颜色
            //       },
            //       {
            //         offset: 1,
            //         color: "#EC2624", // 100% 处的颜色
            //       },
            //     ],
            //   },
            // },
          },
          data: this.labelData,
        }
      ];
      window.echarts.registerMap("china", optionData);
      const option = {
        tooltip: (() => {
          return Object.assign(
              (() => {
                if (this.formatter) {
                  return {
                    formatter: (params) => {
                      return params.value[params.value.length - 1].detail
                    },
                  };
                }
                return {};
              })(),
              {
                backgroundColor: this.option.tipBackgroundColor,
                textStyle: {
                  fontSize: this.option.tipFontSize,
                  color: this.option.tipColor,
                },
              }
          );
        })(),
        // visualMap: {
        //   show: false,
        //   type: 'piecewise',
        //   textStyle: {
        //       color: '#ddc92a',
        //   },
        //   pieces: this.option.showPercent ? [
        //       {
        //           min: 40,
        //           color: '#af060d',
        //           label: '>40%',
        //       },
        //       {
        //           max: 40,
        //           min: 10,
        //           color: '#c49844',
        //           label: '10%~40%',
        //       },
        //       {
        //           max: 10,
        //           min: 5,
        //           color: '#3a8ef1',
        //           label: '5%~10%',
        //       },
        //       {
        //           max: 5,
        //           min: 2,
        //           color: '#77b8f2',
        //           label: '2%~5%',
        //       },
        //       {
        //           max: 2,
        //           min: 0.1,
        //           color: '#a7c9ec',
        //           label: '0.01~2%',
        //       },
        //       {
        //           max: 0.1,
        //           min: 0,
        //           color: '#ffffff',
        //           label: '0%',
        //       }
        //   ] : undefined,
        //   inRange: {
        //       color: ['#a7c9ec', '#77b8f2', '#3a8ef1', '#c49844', '#af060d']
        //   }
        // },
        geo: this.geoOption,
        series: optionSeries,
      };
      this.myChart.off("mouseover");
      this.myChart.off("mouseout");
      this.myChart.off("georoam");

      this.myChart.on("mouseover", () => {
      });
      this.myChart.on("mouseout", () => {
        this.bannerCount = 0;
      });
      this.myChart.on("click", (e) => {
        console.log(e)
        if (e.data && e.value && e.value.length) {
          const code = e.value[e.value.length - 1]?.code
          window.open(`https://www.icplant.com/jump/index.html?p=${code}`)
        }
      })
      this.myChart.on("georoam", (e) => {
        const option = this.myChart.getOption();
        const geo = option.geo[0];
        this.centerData = geo.center;
        this.zoomData = geo.zoom;
        if (this.zoomData < 1) this.zoomData = 1;
      });

      this.myChart.resize();
      this.myChart.setOption(this.echartsOptionHandler(option), true);
      // });
    },
  },
};
</script>
